
function $parcel$defineInteropFlag(a) {
  Object.defineProperty(a, '__esModule', {value: true, configurable: true});
}

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global = globalThis;
    var parcelRequire = $parcel$global["parcelRequired477"];
var parcelRegister = parcelRequire.register;
parcelRegister("f16xs", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", () => $332998d1f8e3682c$export$2e2bcd8739ae039);
/* prettier-ignore */ /**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */ //Korean
var $332998d1f8e3682c$export$2e2bcd8739ae039 = {
    'editorExtensionLinkCreate.confluencePage.newDraftTitle': "\uC81C\uBAA9\uC774 \uC5C6\uB294 \uD398\uC774\uC9C0",
    'editorExtensionLinkCreate.confluencePage.quickInsert.description': "\uC0C8 \uD398\uC774\uC9C0\uB97C \uB9CC\uB4E4\uACE0 \uB9C1\uD06C\uB85C \uC0BD\uC785",
    'editorExtensionLinkCreate.confluencePage.quickInsert.title': "Confluence \uD398\uC774\uC9C0 \uB9CC\uB4E4\uAE30",
    'editorExtensionLinkCreate.confluencePage.successFlag.action.open': "Confluence\uC5D0\uC11C \uC5F4\uAE30",
    'editorExtensionLinkCreate.confluencePage.successFlag.description': "\uD398\uC774\uC9C0\uB97C \uB9CC\uB4E4\uC5C8\uC2B5\uB2C8\uB2E4",
    'editorExtensionLinkCreate.confluencePage.successFlag.title': "\uD398\uC774\uC9C0\uB97C \uB9CC\uB4E6",
    'editorExtensionLinkCreate.confluencePage.title': "\uC0C8 \uD398\uC774\uC9C0 \uB9CC\uB4E4\uAE30",
    'editorExtensionLinkCreate.genericError.description': "\uD398\uC774\uC9C0\uB97C \uC0C8\uB85C \uACE0\uCE5C \uD6C4 \uB2E4\uC2DC \uC2DC\uB3C4\uD558\uC138\uC694.",
    'editorExtensionLinkCreate.genericError.title': "\uBB38\uC81C\uAC00 \uBC1C\uC0DD\uD588\uC2B5\uB2C8\uB2E4",
    'editorExtensionLinkCreate.jiraIssue.quickInsert.description': "\uC778\uB77C\uC778 \uC774\uC288\uB97C \uB9CC\uB4E4\uACE0 \uC774\uC288\uB97C \uB9C1\uD06C\uB85C \uC0BD\uC785",
    'editorExtensionLinkCreate.jiraIssue.quickInsert.title': "Jira \uC774\uC288 \uB9CC\uB4E4\uAE30",
    'editorExtensionLinkCreate.jiraIssue.successFlag.action.open': "Jira\uC5D0\uC11C \uC5F4\uAE30",
    'editorExtensionLinkCreate.jiraIssue.successFlag.description': "\uC774\uC288\uB97C \uB9CC\uB4E4\uC5C8\uC2B5\uB2C8\uB2E4",
    'editorExtensionLinkCreate.jiraIssue.successFlag.title': "\uC774\uC288\uB97C \uB9CC\uB4E6",
    'editorExtensionLinkCreate.jiraIssue.title': "\uC0C8 \uC774\uC288 \uB9CC\uB4E4\uAE30",
    'editorExtensionLinkCreate.keyword.create': "\uB9CC\uB4E4\uAE30",
    'editorExtensionLinkCreate.keyword.issue': "\uC774\uC288",
    'editorExtensionLinkCreate.keyword.new': "\uC0C8 \uD56D\uBAA9",
    'editorExtensionLinkCreate.keyword.page': "\uD398\uC774\uC9C0",
    'editorExtensionLinkCreate.keyword.publish': "\uAC8C\uC2DC",
    'editorExtensionLinkCreate.keyword.raise': "\uC81C\uAE30",
    'editorExtensionLinkCreate.keyword.space': "\uC2A4\uD398\uC774\uC2A4",
    'editorExtensionLinkCreate.keyword.ticket': "\uD2F0\uCF13"
};

});


//# sourceMappingURL=ko.e49896fc.js.map
